// Chrome Web Store listing for "Diffit for Chrome". Shared by every surface that
// points teachers at the extension (the YouTube modal, the loading-screen tips),
// so the listing URL is only spelled out once.
export const CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/diffit-for-chrome/gohaeddhlhcjokibckjmphegiieiakjh';
